__turbopack_context__.v({
  "assessment-form__list": "self-assessment-form-module-scss-module__-OxRLq__assessment-form__list",
});
